import { render, staticRenderFns } from "./MenuLinkSidebar.vue?vue&type=template&id=467c4160&functional=true&"
import script from "./MenuLinkSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuLinkSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MenuLinkSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports